<template>
  <van-overlay :show="visible" :z-index="3001" class="loading-box">
    <div class="wrapper" @click.stop>
      <van-loading size="56px" text-size="16px" vertical>
        <span v-if="hasText" class="text">{{ text }}</span>
      </van-loading>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'PopLoading',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isTip: {
      type: Boolean,
      default: true
    },
    tip: {
      type: String,
      default: '加载中...'
    }
  },
  watch: {
    loading(val) {
      this.visible = val
    },
    isTip(val) {
      this.hasText = val
    },
    tip(val) {
      this.text = val
    }
  },
  data() {
    return {
      visible: this.loading,
      hasText: this.isTip,
      text: this.tip
    }
  },
  methods: {
    show(options = {}) {
      this.hasText = options.hasText || true
      this.text = options.text || '加载中...'
      this.visible = true
    },
    hide() {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.loading-box {
  background: rgba(0, 0, 0, 0.8);
}
.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .text {
    color: #fff;
    margin-top: 10px;
  }
}
</style>